// Disable the rule wanting default export until we have more constants
// eslint-disable-next-line import/prefer-default-export
export const HELPDESK_EMAIL = 'helpdesk@mintel.com';
